import settingsBase from "../helpers/configuration/loadSettings";

export default {
	...settingsBase,
	dropdownLanguages: [
		{ code: 'it', label: 'Italiano' },
		{ code: 'en', label: 'English' },
		{ code: 'de', label: 'Deutsch' },
		{ code: 'sl', label: 'Slovenščina' }
	]
};
